import { createContext } from 'react';

const ManualSearchContext = createContext();

export default ManualSearchContext;
